import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Home from '../pages/Home';
import Accounts from '../pages/Accounts';
import * as routeNames from '../../constants/routeNames';
import { ROUTE_ACCOUNTS_AMAZON } from '../pages/Accounts/constants/AccountRoutes';

const SwitchAndRoutes = () => {
    return (
        <React.Fragment>
            <Switch>
                <Redirect exact from={routeNames.ROUTE_HOME} to={ROUTE_ACCOUNTS_AMAZON} />
                <Redirect exact from={routeNames.ROUTE_BASE_ACCOUNTS} to={ROUTE_ACCOUNTS_AMAZON} />
                <Route path={routeNames.ROUTE_BASE_ACCOUNTS} component={Accounts}/>
                <Route exact path={routeNames.ROUTE_HOME} component={Home}/>
            </Switch>
        </React.Fragment>
    );
}

export default SwitchAndRoutes;